import React, { memo } from "react";
import { useTheme } from "styled-components";

function Chevron() {
    const theme = useTheme();
    const strokeColor = theme.colors[theme.colorMode].primary;

    return (
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 9L5 5.01567L1 0.999999"
                stroke={strokeColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default memo(Chevron);
